var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('title-card',{attrs:{"title":_vm.title,"disable-title":_vm.disableTitle,"color":_vm.color,"help":_vm.help,"no-padding":true,"sideIcon":_vm.sideIcon}},[_c('v-list',{class:_vm.listColor,attrs:{"dense":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }